import { getUserData, trackAnalyticsEvent } from "../shared/app-interface"
import { INVOKED_SOURCE_KEY, JOB_DETAILS } from "../shared/constants"
import { DOC_TYPES } from "../shared/constants/assessment-flow"

export function trackMixpanelEvent(eventName: string, payload: any = {}) {
    const source = sessionStorage.getItem(INVOKED_SOURCE_KEY)
    let jobDetailsObject = null
    const jobDetails = sessionStorage.getItem(JOB_DETAILS)
    const userData = getUserData()
    console.log(userData, "userx")
    if (jobDetails) {
        try {
            jobDetailsObject = JSON.parse(jobDetails)
        } catch (error) {
            console.error(`Error parsing job details: ${error}`)
        }
    }
    console.table({
        eventName,
        ...payload,
        eventType: "MIXPANEL_EVENT",
        source,
    })
    trackAnalyticsEvent(
        eventName,
        {
            ...payload,
            source,
            user_id: userData?.id,
            "Jobs Fixed Min Salary": jobDetailsObject?.job_info?.max_salary,
            "Job's Fixed Max Salary": jobDetailsObject?.job_info?.min_salary,
            "Job's Avg Incentive": jobDetailsObject?.job_info?.salary_incentive,
            "Job's Earning Potential": jobDetailsObject?.job_info?.earning_potential,
            "Job ID": jobDetailsObject?.job_info?.id,
            "Job city": jobDetailsObject?.job_info?.address?.city?.name,
            "Job area": jobDetailsObject?.job_info?.address?.area,
            "Job state": jobDetailsObject?.job_info?.address?.json_data?.state,
            "Job district": jobDetailsObject?.job_info?.analytics_meta?.Job_district,
            "Job subdistrict":
                jobDetailsObject?.job_info?.analytics_meta?.Job_subdistrict,
            recruiter_ecc_preference: jobDetailsObject?.job_info?.job_employer_preference,
            // "User's Current Salary": jobDetailsObject?.job_info?
            // "User's Expected Salary": jobDetailsObject?.job_info?
            // "Threshold Factor": jobDetailsObject?.job_info?.
            // "Threshold Condition": jobDetailsObject?.job_info?.
            // "User Experience": jobDetailsObject?.job_info?.
            // "Job Experience": jobDetailsObject?.job_info?.
            // "Job Department ID": jobDetailsObject?.job_info?.
            // "Job Department Name": jobDetailsObject?.job_info?.
            // "Job Sub Department ID": jobDetailsObject?.job_info?.
            // "Job Sub Department Name": jobDetailsObject?.job_info?.
            // "Job Collar Type": 124.
            // "User Cohort Type": jobDetailsObject?.job_info?.
            // "User Current City": jobDetailsObject?.job_info?.
            // "User GPS City": jobDetailsObject?.job_info?4.
            // "User App Build Number": jobDetailsObject?.job_info?.
        },
        ["MIXPANEL"]
    )
}
export const getSectionName = (entity: string) => {
    switch (entity) {
        case DOC_TYPES.JOB_PREFERENCE:
            return "Preference Reconfirms"
        case DOC_TYPES.AUDIO_UPLOAD:
            return "English Audio"
        case DOC_TYPES.RESUME:
            return "Resume Upload"
        case DOC_TYPES.DRIVING_LICENSE:
            return "DL Upload"
        case DOC_TYPES.UPLOAD:
            return "Upload"
        case DOC_TYPES.ASSEST:
            return "Assets/Documents"
        default:
            return ""
    }
}
